import { AlenDeviceStatus } from "./IAlenDevice";
import { Shadow } from "./IShadow";

export enum DeviceType {
  HALO = "HALO",
  MAX = "MAX",
  ESSENTIAL = "ESSENTIAL",
  PLUS = "PLUS",
  TRACKER = "TRACKER",
  ALEN = "ALEN",
}

export const deviceTypeToName = (dt: DeviceType): string => {
  switch (dt) {
    case DeviceType.HALO:
      return "Halo";
      break;
    case DeviceType.MAX:
      return "Max";
      break;
    case DeviceType.ESSENTIAL:
      return "Essential";
      break;
    case DeviceType.PLUS:
      return "Plus";
      break;
    case DeviceType.TRACKER:
      return "Tracker";
      break;
    default:
      throw TypeError(`Unknown device type: ${dt}`);
      break;
  }
};

export const deviceTypeToPluralName = (dt: DeviceType): string => {
  switch (dt) {
    case DeviceType.HALO:
      return "Halos";
    case DeviceType.MAX:
      return "Maxes";
    case DeviceType.ESSENTIAL:
      return "Essentials";
    case DeviceType.PLUS:
      return "Plus";
    case DeviceType.TRACKER:
      return "Trackers";
    case DeviceType.ALEN:
      return "Alen";
    default:
      throw TypeError(`Unknown device type: ${dt}`);
  }
};

export interface Device {
  device_id: string; // serial
  property_id: number;
  property: {
    name: string;
  };
  zone_id: number;
  zone: {
    name: string;
    floor: string;
  };
  extra_data?: JSON;
  device_type: DeviceType;
}

export interface DeviceShadow {
  device_id: string; // serial
  property_id: number;
  property_name: string;
  zone_id: number;
  zone_name: string;
  device_type: DeviceType;
  shadow?: Shadow;
}

export interface AlenDevice {
  active_time: number;
  biz_type: number;
  category: string;
  create_time: number;
  icon: string;
  id: string;
  ip: string;
  lat: string;
  local_key: string;
  lon: string;
  model: string;
  name: string;
  online: boolean;
  owner_id: string;
  product_id: string;
  product_name: string;
  status: AlenDeviceStatus[];
  sub: boolean;
  time_zone: string;
  uid: string;
  update_time: number;
  uuid: string;
  location_name: string;
}
